import React, { useRef, useState } from "react";
import DefaultLayout from "app/layouts/DefaultLayout";
import { useNavigate } from "react-router-dom";
import Path from "app/route/Path";
import SegmentedControl from "app/components/commonUI/SegmentedControl";
import ProductGrid from "app/components/Product/ProductGrid";
import ProductGridItem from "app/components/Product/ProductGridItem";
// import MainMenuItem from "app/components/MainMenuItem";
// import CommonConfirmDialog from "app/components/CommonDialog";
// import Path from "app/route/Path";

function Recommend() {
  const navigate = useNavigate();

  const ButtonClicked = () => {
    console.log("ButtonClicked22222");
    navigate(Path.invoiceEmail);
  };

  return (
    <DefaultLayout
      headerProps={{
        headerClassName: "md:!block",
        pageTitle: "請求書確認",
      }}
    >
      <p>請求書</p>

      <button onClick={ButtonClicked}>発行</button>
    </DefaultLayout>
  );
}

export default Recommend;
